/**
 * Brand Discovery - Elegant brand exploration
 * Randomly displays curated brands with refined interactions
 */

class BrandShuffle extends HTMLElement {
  constructor() {
    super();
    this.allBrands = [];
    this.displayCount = 12;
    this.isAnimating = false;
  }

  connectedCallback() {
    // Get elements after component is connected to DOM
    this.button = this.querySelector(".brand-shuffle__button");
    this.grid = this.querySelector(".brand-shuffle__grid");

    // Get all vendors from the data attribute
    const vendorsData = this.getAttribute("data-vendors");

    if (vendorsData) {
      try {
        this.allBrands = JSON.parse(vendorsData);
      } catch (e) {
        console.error("Brand Discovery: Failed to parse vendors data:", e);
      }
    }

    // Initial display
    this.shuffleBrands(false);

    // Add button click listener to trigger elegant refresh
    if (this.button) {
      this.button.addEventListener("click", () => this.shuffleBrands(true));
    }
  }

  shuffleBrands(animate = true) {
    if (this.isAnimating || this.allBrands.length === 0) return;

    if (animate) {
      this.isAnimating = true;

      // Elegant fade out
      const items = this.grid.querySelectorAll(".brand-shuffle__item");
      items.forEach((item, index) => {
        setTimeout(() => {
          item.style.opacity = "0";
          item.style.transform = "translateY(8px)";
        }, index * 30); // Staggered fade
      });

      // Wait for fade out, then update content
      setTimeout(() => {
        const randomBrands = this.getRandomBrands(this.displayCount);
        this.updateGrid(randomBrands);

        // Elegant fade in
        items.forEach((item, index) => {
          setTimeout(() => {
            item.style.opacity = "1";
            item.style.transform = "translateY(0)";
          }, index * 30);
        });

        setTimeout(() => {
          this.isAnimating = false;
        }, items.length * 30 + 400);
      }, items.length * 30 + 200);
    } else {
      // Initial load without animation
      const randomBrands = this.getRandomBrands(this.displayCount);
      this.updateGrid(randomBrands);
    }
  }

  getRandomBrands(count) {
    const shuffled = [...this.allBrands].sort(() => Math.random() - 0.5);
    return shuffled.slice(0, count);
  }

  updateGrid(brands) {
    const items = this.grid.querySelectorAll(".brand-shuffle__item");

    brands.forEach((brand, index) => {
      if (items[index]) {
        const link = items[index].querySelector(".brand-shuffle__link");
        const name = items[index].querySelector(".brand-shuffle__name");

        if (link && name) {
          const searchUrl = `/search?q=${encodeURIComponent(
            'vendor:"' + brand + '"'
          )}`;
          link.setAttribute("href", searchUrl);
          name.textContent = brand;
        }
      }
    });
  }
}

customElements.define("brand-shuffle", BrandShuffle);
